import { Box, Grid } from '@mui/material';
import PaperPanelInfo from 'src/components/PaperPanelInfo';
import Subtitle from 'src/components/Subtitle';
import { DebenturesResumeData } from 'src/types/operations/debentures';

type OperationDebenturesResumeCharacteristicsProps = {
  data?: DebenturesResumeData['characteristics'];
  isLoading?: boolean;
};

export default function OperationDebenturesResumeCharacteristics({
  data,
  isLoading = false,
}: OperationDebenturesResumeCharacteristicsProps) {
  return (
    <Box p={1}>
      <Subtitle title="Características" />
      <Box py={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md>
            <PaperPanelInfo
              first
              title="Forma"
              value={data?.forma}
              loading={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md>
            <PaperPanelInfo
              title="Garantia / Espécie"
              value={data?.garantiaEspecie}
              loading={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md>
            <PaperPanelInfo
              title="Classe"
              value={data?.classe}
              loading={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md>
            <PaperPanelInfo
              title="Situação"
              value={data?.situacao}
              loading={isLoading}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
